/*!
 * TableSelection library v1.0.0 (https://github.com/PXLWidgets/table-selection)
 * Copyright (c) 2019 Wouter Smit
 * Licensed under MIT (https://github.com/PXLWidgets/table-selection/blob/master/LICENSE)
*/

import { TableSelection } from './ts/TableSelection';

export default TableSelection;
